(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["firmware-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const allWrappers = document.querySelectorAll(".faq-title-wrapper");

    allWrappers.forEach(wrapper => {
      // Skip toggle if it's an always open block
      if (wrapper.classList.contains("faq-always-open")) return;

      const title = wrapper.querySelector("h3");
      const collapse = wrapper.querySelector(".faq-collapse");

      if (title && collapse) {
        // ensure collapsed by default
        collapse.classList.remove("show");
        title.classList.remove("open");

        title.addEventListener("click", () => {
          collapse.classList.toggle("show");
          title.classList.toggle("open");
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-and-text-animated"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {

setTimeout(() => {

let mm = gsap.matchMedia();

let imageRight = gsap.utils.toArray('.ImageOnRight');
let videosItem = gsap.utils.toArray('.videos');

imageRight.forEach((imageRightWrapper) => {
let imageRightText = imageRightWrapper.querySelector('.ITAContainerText');
let imageRightImage = imageRightWrapper.querySelector('.ITAContainerImage');
mm.add("(min-width: 770px)", () => {
let ImageTextAnimatedRight = gsap.timeline({
scrollTrigger: {
trigger: imageRightWrapper,
start: "top center",
end: "",
scrub: false
}
});
ImageTextAnimatedRight.fromTo(imageRightText, {x: -180, opacity: 0}, {x: 0,opacity: 1});
ImageTextAnimatedRight.call(() => {
videosItem[0]?.play();
});
ImageTextAnimatedRight.fromTo(imageRightImage, {x: 180, opacity: 0}, {x: 0,opacity: 1});
ImageTextAnimatedRight.call(() => {
videosItem[1]?.play();
});
});
mm.add("(max-width: 769px)", () => {
let ImageTextAnimatedRight = gsap.timeline({
scrollTrigger: {
trigger: ".ImageOnRight",
start: "top+=120 60%",
end: "bottom 80%"
}
});
ImageTextAnimatedRight.fromTo(imageRightImage, {y: 400, opacity: 0}, {
y: 0,
opacity: 1
});
ImageTextAnimatedRight.call(() => {
videosItem[0]?.play();
});
ImageTextAnimatedRight.fromTo(imageRightText, {y: -400, opacity: 0}, {
y: 0,
opacity: 1
});
ImageTextAnimatedRight.call(() => {
videosItem[1]?.play();
});
});
});


let imageLeft = gsap.utils.toArray('.ImageOnLeft');
imageLeft.forEach((imageLeftWrapper) => {
let imageLeftText = imageLeftWrapper.querySelector('.ITAContainerText');
let imageLeftImage = imageLeftWrapper.querySelector('.ITAContainerImage');

mm.add("(min-width: 769px)", () => {
let ImageTextAnimatedLeft = gsap.timeline({
scrollTrigger: {
trigger: imageLeftWrapper,
start: "top center",
end: "",
scrub: false
},
onEnter: () => {
document.querySelectorAll('.videos')[0]?.play();
document.querySelectorAll('.videos')[1]?.play();
}
});

ImageTextAnimatedLeft.fromTo(imageLeftText, {x: 180, opacity: 0}, {x: 0, opacity: 1});
ImageTextAnimatedLeft.fromTo(imageLeftImage, {x: -180, opacity: 0}, {x: 0,opacity: 1});
});
mm.add("(max-width: 768px)", () => {
let ImageTextAnimatedLeft = gsap.timeline({
scrollTrigger: {
trigger: imageLeftWrapper,
start: "top center",
end: ""
},
onEnter: () => {
document.querySelectorAll('.videos')[0]?.play();
document.querySelectorAll('.videos')[1]?.play();
}
});

ImageTextAnimatedLeft.fromTo(imageLeftText, {y: 300, opacity: 0}, {
y: 0,
opacity: 1
});
ImageTextAnimatedLeft.fromTo(imageLeftImage, {y: -300, opacity: 0}, {
y: 0,
opacity: 1
});
});
});

}, 1000);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-and-text"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => {

        }, 1000);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-v3"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {

setTimeout(() => {

let mm = gsap.matchMedia();

let imageRight = gsap.utils.toArray('.ImageOnRight');
let videosItem = gsap.utils.toArray('.videos');

imageRight.forEach((imageRightWrapper) => {
let imageRightText = imageRightWrapper.querySelector('.ITAContainerText');
let imageRightImage = imageRightWrapper.querySelector('.ITAContainerImage');
mm.add("(min-width: 770px)", () => {
let ImageTextAnimatedRight = gsap.timeline({
scrollTrigger: {
trigger: imageRightWrapper,
start: "top center",
end: "",
scrub: false
}
});
ImageTextAnimatedRight.fromTo(imageRightText, {x: -180, opacity: 0}, {x: 0,opacity: 1});
ImageTextAnimatedRight.call(() => {
videosItem[0]?.play();
});
ImageTextAnimatedRight.fromTo(imageRightImage, {x: 180, opacity: 0}, {x: 0,opacity: 1});
ImageTextAnimatedRight.call(() => {
videosItem[1]?.play();
});
});
mm.add("(max-width: 769px)", () => {
let ImageTextAnimatedRight = gsap.timeline({
scrollTrigger: {
trigger: ".ImageOnRight",
start: "top+=120 60%",
end: "bottom 80%"
}
});
ImageTextAnimatedRight.fromTo(imageRightImage, {y: 400, opacity: 0}, {
y: 0,
opacity: 1
});
ImageTextAnimatedRight.call(() => {
videosItem[0]?.play();
});
ImageTextAnimatedRight.fromTo(imageRightText, {y: -400, opacity: 0}, {
y: 0,
opacity: 1
});
ImageTextAnimatedRight.call(() => {
videosItem[1]?.play();
});
});
});


let imageLeft = gsap.utils.toArray('.ImageOnLeft');
imageLeft.forEach((imageLeftWrapper) => {
let imageLeftText = imageLeftWrapper.querySelector('.ITAContainerText');
let imageLeftImage = imageLeftWrapper.querySelector('.ITAContainerImage');

mm.add("(min-width: 769px)", () => {
let ImageTextAnimatedLeft = gsap.timeline({
scrollTrigger: {
trigger: imageLeftWrapper,
start: "top center",
end: "",
scrub: false
},
onEnter: () => {
document.querySelectorAll('.videos')[0]?.play();
document.querySelectorAll('.videos')[1]?.play();
}
});

ImageTextAnimatedLeft.fromTo(imageLeftText, {x: 180, opacity: 0}, {x: 0, opacity: 1});
ImageTextAnimatedLeft.fromTo(imageLeftImage, {x: -180, opacity: 0}, {x: 0,opacity: 1});
});
mm.add("(max-width: 768px)", () => {
let ImageTextAnimatedLeft = gsap.timeline({
scrollTrigger: {
trigger: imageLeftWrapper,
start: "top center",
end: ""
},
onEnter: () => {
document.querySelectorAll('.videos')[0]?.play();
document.querySelectorAll('.videos')[1]?.play();
}
});

ImageTextAnimatedLeft.fromTo(imageLeftText, {y: 300, opacity: 0}, {
y: 0,
opacity: 1
});
ImageTextAnimatedLeft.fromTo(imageLeftImage, {y: -300, opacity: 0}, {
y: 0,
opacity: 1
});
});
});

}, 1000);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mlm-premium-mem-plan"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
const countrySelect = document.querySelector(".CountryWrapper select");
const priceEl = document.querySelector(".plan-right .price");
const monthlyEl = document.querySelector(".plan-right .monthly");

// Build a whitelist of valid plans from the original HTML
const validPlans = {};
Array.from(countrySelect.options).forEach(option => {
const key = option.value; // "usa" or "canada"
validPlans[key] = {
plan: option.dataset.planPrice,
monthly: option.dataset.monthlyPrice
};
});

function updatePrices() {
const selectedKey = countrySelect.value;
if (validPlans[selectedKey]) {
priceEl.textContent = validPlans[selectedKey].plan;
monthlyEl.textContent = validPlans[selectedKey].monthly;
} else {
countrySelect.selectedIndex = 0;
const defaultKey = countrySelect.options[0].value;
priceEl.textContent = validPlans[defaultKey].plan;
monthlyEl.textContent = validPlans[defaultKey].monthly;
}
}

// Update on change
countrySelect.addEventListener("change", updatePrices);

// Initialize default
updatePrices();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mlm-premium-winter-plan"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
const countrySelect = document.querySelector(".CountryWrapper select");
const priceEl = document.querySelector(".plan-right .price");
const monthlyEl = document.querySelector(".plan-right .monthly");

// Build a whitelist of valid plans from the original HTML
const validPlans = {};
Array.from(countrySelect.options).forEach(option => {
const key = option.value; // "usa" or "canada"
validPlans[key] = {
plan: option.dataset.planPrice,
monthly: option.dataset.monthlyPrice
};
});

function updatePrices() {
const selectedKey = countrySelect.value;
if (validPlans[selectedKey]) {
priceEl.textContent = validPlans[selectedKey].plan;
monthlyEl.textContent = validPlans[selectedKey].monthly;
} else {
countrySelect.selectedIndex = 0;
const defaultKey = countrySelect.options[0].value;
priceEl.textContent = validPlans[defaultKey].plan;
monthlyEl.textContent = validPlans[defaultKey].monthly;
}
}

// Update on change
countrySelect.addEventListener("change", updatePrices);

// Initialize default
updatePrices();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-page-v2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    const checkboxes = document.querySelectorAll('.RangefinderCheckbox');

    const desktopInput =
        document.getElementById('RangefinderVariant');

    const mobileInput =
        document.getElementById('RangefinderVariantMobile');

    if (!checkboxes.length) return;

    function updateRangefinder() {
        const selectedIds = [];

        checkboxes.forEach((checkbox) => {
            const card = checkbox.closest('.RangefinderCard');

            if (card) {
                card.classList.toggle(
                    'active',
                    checkbox.checked
                );
            }

            if (checkbox.checked) {
                selectedIds.push(
                    checkbox.dataset.id
                );
            }
        });

        const value = selectedIds.join(',');

        if (desktopInput) {
            desktopInput.value = value;
        }

        if (mobileInput) {
            mobileInput.value = value;
        }
    }

    checkboxes.forEach((checkbox) => {
        checkbox.addEventListener(
            'change',
            updateRangefinder
        );
    });

    updateRangefinder();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-page-v3"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    const checkboxes = document.querySelectorAll('.RangefinderCheckbox');

    const desktopInput =
        document.getElementById('RangefinderVariant');

    const mobileInput =
        document.getElementById('RangefinderVariantMobile');

    if (!checkboxes.length) return;

    function updateRangefinder() {
        const selectedIds = [];

        checkboxes.forEach((checkbox) => {
            const card = checkbox.closest('.RangefinderCard');

            if (card) {
                card.classList.toggle(
                    'active',
                    checkbox.checked
                );
            }

            if (checkbox.checked) {
                selectedIds.push(
                    checkbox.dataset.id
                );
            }
        });

        const value = selectedIds.join(',');

        if (desktopInput) {
            desktopInput.value = value;
        }

        if (mobileInput) {
            mobileInput.value = value;
        }
    }

    checkboxes.forEach((checkbox) => {
        checkbox.addEventListener(
            'change',
            updateRangefinder
        );
    });

    updateRangefinder();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rapsodo-mission"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRapsodoMission(section) {
      if (!section || section.dataset.missionInitialized === 'true') return;

      section.dataset.missionInitialized = 'true';

      var outlineElements = Array.prototype.slice.call(
        section.querySelectorAll('.RapsodoMission__outline')
      );

      if (!outlineElements.length) return;

      // Keep all outline text hidden until its scroll threshold is reached.
      outlineElements.forEach(function (element) {
        element.classList.remove('is-visible');
      });

      var ticking = false;

      function updateOutlineVisibility() {
        var scrollY = window.pageYOffset || document.documentElement.scrollTop;
        var sectionTop = section.getBoundingClientRect().top + scrollY;
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        // Reveal the first outline as the section enters the viewport,
        // then reveal the remaining outlines at staggered scroll positions.
        var firstRevealPoint = sectionTop - viewportHeight * 0.75;
        var revealSpacing = viewportHeight * 0.18;
        var revealCount = 0;

        outlineElements.forEach(function (element, index) {
          var revealPoint = firstRevealPoint + (index * revealSpacing);
          // Reveal each outline only once. Keep it visible even if the user
          // scrolls back up; it resets naturally when the page is refreshed.
          if (scrollY >= revealPoint && !element.classList.contains('is-visible')) {
            element.classList.add('is-visible');
          }
        });

        ticking = false;
      }

      function requestUpdate() {
        if (!ticking) {
          window.requestAnimationFrame(updateOutlineVisibility);
          ticking = true;
        }
      }

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      updateOutlineVisibility();
    }

    function initAllRapsodoMissions() {
      document.querySelectorAll('.RapsodoMission').forEach(initRapsodoMission);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllRapsodoMissions);
    } else {
      initAllRapsodoMissions();
    }

    // Re-initialize sections when Shopify reloads them in the Theme Editor.
    document.addEventListener('shopify:section:load', function (event) {
      var shopifySection = event.target;
      var mission = shopifySection.querySelector
        ? shopifySection.querySelector('.RapsodoMission')
        : null;

      if (mission) {
        mission.dataset.missionInitialized = 'false';
        initRapsodoMission(mission);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["who-we-are"] && !Shopify.designMode) return;
  try {
    
var acc = document.getElementsByClassName("accordionBox");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.querySelector('.R-panel');
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
